import { RefObject } from 'react';

import {
  useMeasureDimensions,
  useOptionalPropsBridge,
} from '@spotify/confidence-core-react';

import { PageContentBridgeProps } from './types';

type ContentOffsets = {
  actionBarRef: RefObject<HTMLDivElement | null>;
  tabsRef: RefObject<HTMLDivElement | null>;
  isNested: boolean;
  actionBarTopOffset: number;
  contentTopOffset: number;
};

export const useContentOffsets = (
  parentContentTopOffset: number | undefined,
): ContentOffsets => {
  const [actionBarRef, { height: actionBarHeight }] =
    useMeasureDimensions<HTMLDivElement>();
  const [tabsRef, { height: tabsHeight }] =
    useMeasureDimensions<HTMLDivElement>();

  const isNested = parentContentTopOffset !== undefined;
  const resolvedParentOffset = parentContentTopOffset ?? 0;
  const actionBarTopOffset = resolvedParentOffset + tabsHeight;
  const contentTopOffset = actionBarTopOffset + actionBarHeight;

  return {
    actionBarRef,
    tabsRef,
    isNested,
    actionBarTopOffset,
    contentTopOffset,
  };
};

export const usePageContentTopOffset = (): number => {
  const bridgeProps = useOptionalPropsBridge<PageContentBridgeProps>();
  return bridgeProps?.contentTopOffset ?? 0;
};
